import { render, staticRenderFns } from "./Display3DWithoutDEM.vue?vue&type=template&id=a5253b4e&scoped=true&"
import script from "./Display3DWithoutDEM.vue?vue&type=script&lang=js&"
export * from "./Display3DWithoutDEM.vue?vue&type=script&lang=js&"
import style0 from "./Display3DWithoutDEM.vue?vue&type=style&index=0&id=a5253b4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5253b4e",
  null
  
)

export default component.exports